import React from "react";
//import axios from 'axios';
import './Signup2.css';

//import AuthService from '../Services/auth.service';
class Signup2 extends React.Component {

constructor(){
    super();
    this.state = {
        cats : [],
    }
  // this.signUp = this.signUp.bind(this);
}
 

  render() {
    return <div>

                <div className="row  ">


                  <div className=" p-5 center-space">
                    <div className="text-center">
                      <a className="" href="/#">  <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid mb-2 popup-img" />  </a>
                      {/* <a className="" href="/#"> <img src="/assets/images/logo/logo-3.png" alt="" title="" className="img-fluid secondary-logo" /> </a> */}
                    </div>
                            <div className="row-form  mt-3  mb-5 num-left">
                                        <h6 className="green-label ">Mobile Number</h6>
                                        <input className="form-controls " type="text" placeholder="" id="example-email-input" maxlength="10" onChange={e => this.mobileNo = e.target.value}/>
                                        <p class={this.props.msgClass}>{this.props.msg}</p>

                                        </div> 
                                        <div className="text-center ">
                                              <button type="button" className=" add-to-cart2 btnn " onClick={() => this.props.updateState(this.mobileNo)}>Send OTP</button><br/>
                                              <button type="button" className="  btnn  btn-outline-green" onClick={() => this.props.handleCancel('false')}>Cancel</button></div>
                            </div>
                </div>
    </div>
    }
}

export default Signup2;
